import React, { Component, Fragment } from 'react';
import { ToastContainer, toast } from 'react-toastify';

import '!style-loader!css-loader!react-toastify/dist/ReactToastify.min.css';
import NotificationService from 'services/NotificationService';
import AchievementNotificationService from 'components/AchievementNotificationService';
import SnackbarWrapper from 'components/SnackbarWrapper/SnackbarWrapper';


class NotificationRenderer extends Component {
  state = {
    activeSnackBar: null,
    html5: [],
    snackbar: [],
    toast: [],
  };

  componentDidMount() {
    this.showNotification = NotificationService.subscribe('showNotification', (data) => this.processNotification(data));
    this.closeSnackBarService = NotificationService.subscribe('closeSnackbar', () => this.processSnackbar());
  }

  componentWillUnmount() {
    this.showNotification.unsubscribe();
    this.closeSnackBarService.unsubscribe();
  }

  processNotification = (data) => {
    const { type } = data;
    const notificationQueue = this.state[type];
    notificationQueue.push({ ...data });

    this.setState({ [type]: notificationQueue }, () => this.renderNotification(type));
  };

  processSnackbar = () => {
    this.setState({ activeSnackBar: null });
    NotificationService.unblock(NotificationService.type.SNACKBAR);
  };

  closeSnackBar = () => {
    if (this.state.activeSnackBar && !this.state.activeSnackBar.closeOnClickAway) {
      return;
    }
    this.setState({ activeSnackBar: null });
    NotificationService.unblock(NotificationService.type.SNACKBAR);
  };

  renderSnackbar = (activeSnackBar) => {
    // prepare SnackBar
    const { config } = activeSnackBar;
    if (typeof config.onClose === 'function') {
      const customHandler = config.onClose;
      const combinedHandler = () => {
        customHandler();
        this.closeSnackBar();
      };
      if (config.closeOnClickAway) {
        config.onClose = combinedHandler;
      }
    } else {
      config.onClose = this.closeSnackBar;
    }
    this.setState({ activeSnackBar: config });
  };

  renderToast = (activeToast) => {
    // extract type & text and group all other settings into config
    const { text, config } = activeToast;
    const { subtype, isDefault, ...settings } = config;

    const settingsObj = {
      ...settings,
      onClose: typeof settings.onClose === 'function' ? settings.onClose : null,
    };

    if (isDefault) {
      toast(text, settingsObj);
    } else {
      toast[subtype](text, settingsObj);
    }
  };

  renderNotification = (type) => {
    const notificationQueue = this.state[type];

    if (notificationQueue.length) {
      const activeNotification = notificationQueue.shift();
      switch (type) {
        case NotificationService.type.TOAST:
          this.renderToast(activeNotification);
          break;

        case NotificationService.type.SNACKBAR:
          this.renderSnackbar(activeNotification);
          break;

        default:
      }

      this.setState({ [type]: notificationQueue });
    }
  };

  render() {
    return (
      <Fragment>
        <ToastContainer />

        {this.state.activeSnackBar && <SnackbarWrapper {...this.state.activeSnackBar} />}

        <AchievementNotificationService />
      </Fragment>
    );
  }
}

export default NotificationRenderer;
